import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.salesrep/territory-manager/territory/territory-edit.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import resolve from "ioc/resolve";
import modals from 'webmodals/modals'
import DivisionPicker from 'emun.salesrep/territory-manager/division/picker/division-picker'
import ZipcodePicker from 'emun.salesrep/territory-manager/zipcode/picker/zipcode-picker'
import ServiceBus from "servicestack/service-bus";

class TerritoryEditController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
	}
	$onInit() {
		const $ctrl = this;
		const id = $ctrl.territoryId;
		console.info("id", id);
		$ctrl.bus = new ServiceBus();
		if (id == "create") {
			$ctrl.region = { id: "create" };
		} else {
			let options = {
				url: "QueryTerritories.json",
				criteria: {
					Id: id
				},
				autoLoad: true,
				append: false,
				pageSize: 24,
				onLoaded: args => {
					$ctrl.territory = args.first;
				}
			};
			$ctrl.query = new AutoQuery(options);
		}
		$ctrl.zipcodes = new AutoQuery({
			url: "QueryZipcodes.json",
			criteria: {
				TerritoryId: id
			},
			autoLoad: true
		});
		$ctrl.divisions = new AutoQuery({
			url: "QueryDivisions.json",
			criteria: {
				TerritoryId: id
			},
			autoLoad: true
		});
	}
	submit(close) {
		const $ctrl = this;
		console.info("$ctrl.territory", $ctrl.territory, $ctrl.territoryId);
		const action = `${$ctrl.territoryId == "create" ? "Cre" : "Upd"
			}ateTerritory.json`;

		return $ctrl.bus.send(action, $ctrl.territory).then((res) => {
			$ctrl.territory.id = res.data.id;
			$ctrl.divisions.criteria.TerritoryId = $ctrl.territory.id;
			$ctrl.zipcodes.criteria.TerritoryId = $ctrl.territory.id;
			if (close) resolve("$state").go("territories");
		});
	}

	addDivision() {
		let $ctrl = this;
		$ctrl.divisionIds = [];

		return DivisionPicker({
			title: "Select Divisions...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false,
		}).then((result) => {
			$ctrl.submit().then(function (res) {
				$ctrl.bus.send("AddTerritoryDivisions", {
					TerritoryId: $ctrl.territory.id,
					DivisionIds: result
				}).then(function (response) {
					$ctrl.divisions.load();
				});
			});
		});
	}
	addZipcode() {
		let $ctrl = this;
		$ctrl.zipcodeIds = [];

		return ZipcodePicker({
			title: "Select Zipcodes...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false,
		}).then((result) => {
			$ctrl.submit().then(function (res) {
				$ctrl.bus.send("AddTerritoryZipcodes", {
					TerritoryId: $ctrl.territory.id,
					ZipcodeIds: result
				}).then(function (response) {
					$ctrl.zipcodes.load();
				});
			});
		});
	}

	deleteDivision(division) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + division.name, "Remove Division?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteTerritoryDivision.json", {
						TerritoryId: $ctrl.territory.id,
						DivisionId: division.id
					})
					.then(function () {
						return $ctrl.divisions.load(true);
					})
					.catch(

					);
			});
	}
	deleteAllZipcodes() {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove all zipcodes?", "Remove Zipcode?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteAllTerritoryZipcodex.json", {
						TerritoryId: $ctrl.territory.id
					})
					.then(function () {
						return $ctrl.zipcodes.load(true);
					})
					.catch(

					);
			});
	}
	deleteZipcode(zipcode) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + zipcode.id, "Remove Zipcode?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteTerritoryZipcode.json", {
						TerritoryId: $ctrl.territory.id,
						ZipcodeId: zipcode.id
					})
					.then(function () {
						return $ctrl.zipcodes.load(true);
					})
					.catch(

					);
			});
	}

}

let TerritoryEdit = {
	controller: TerritoryEditController,
	bindings: {
		territoryId: "@"
	},
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default TerritoryEdit;
